import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Path 429",
  "use": "icon-Path 429-usage",
  "viewBox": "0 0 18.926 10.236",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18.926 10.236\" id=\"icon-Path 429\">\n  <path id=\"icon-Path 429_Path_429\" data-name=\"Path 429\" d=\"M803.8,242.4h-9a4.992,4.992,0,0,0-5.5-3.7,5.1,5.1,0,0,0-4.4,4.5,5.1,5.1,0,0,0,10,1.9h3.2v2.6h4v-2.6h1.7Zm-13.5,3.7a2.412,2.412,0,0,1-2.8-2.8,2.569,2.569,0,0,1,2-2,2.412,2.412,0,0,1,2.8,2.8A2.443,2.443,0,0,1,790.3,246.1Z\" transform=\"translate(-784.875 -238.664)\" fill=\"#c7c7c7\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/Path 429.svg
// module id = CaNN
// module chunks = 3